<template>
  <div>
    <v-form ref="inputForm" @submit.prevent="">

      <div v-if="type == constants.inOutType_Income">

        <div :class="inError ? 'theme--light error--text shake' : ''" v-html="elsLabel.IncomeList" class="subtitle-enquiry my-5 px-10"> </div>
        <div v-show="inError" class="theme--light error--text mb-5 px-10" v-html="$let('RequiredFieldEmptyMessage')"></div>
        
        <v-row class="financial-details_page px-10">
          <div v-if="elsInUse.InInOutID" class="financial-flex--size">
            <Combobox
              v-model="model.inOutID" 
              :items="inOutDS"
              :returnObject="true"
              :label="elsLabel.InInOutID"
              :helperText="elsHelperText.InInOutID"
              :rules="[elsRequired.InInOutID ? rules.required : true]">
            </Combobox>
          </div>
          <div v-if="elsInUse.InFrequency" class="financial-flex--size">
            <Combobox
              v-model="model.frequency" 
              :items="frequencyDS" 
              :returnObject="true"
              :label="elsLabel.InFrequency"
              :helperText="elsHelperText.InFrequency"
              :rules="[elsRequired.InFrequency ? rules.required : true]">
            </Combobox>
          </div>
          <div v-if="elsInUse.InAmount" class="financial-flex--size">
            <Currency
              v-model="model.amount" 
              :label="elsLabel.InAmount"
              :rules="[rules.numeric, rules.notZero, elsRequired.InAmount ? rules.required : true]"
              :helperText="elsHelperText.InAmount"
              :options="currencyOptions">
            </Currency>
          </div>
          <div v-if="elsInUse.InAgency" class="financial-flex--size">
            <TextField
              maxlength="20"
              v-model="model.agency" 
              :label="elsLabel.InAgency"
              :helperText="elsHelperText.InAgency"
              :rules="[rules.text, elsRequired.InAgency ? rules.required : true]">
            </TextField>
          </div>
          <div v-if="elsInUse.InBalance" class="financial-flex--size">
            <Currency
              v-model="model.balance" 
              :label="elsLabel.InBalance"
              :rules="[rules.numeric, elsRequired.InBalance ? rules.required : true]"
              :helperText="elsHelperText.InBalance"
              :options="currencyOptions">
            </Currency>
          </div>
          <div class="financial-flex--size flex-1 text-center">
            <BaseButton
              @click="_addToList"
              :label="$let('AddToList')">
            </BaseButton>
          </div>
        </v-row>
        
        <div v-if="value && value.length > 0" class="Table--row mt-10">
          <div class="Table--data">
            <div class="flex-row"> 
              <div class="Table--cell" v-if="elsInUse.OutInOutID"><div style="padding: 0;">{{ elsLabel.InInOutID }}</div></div>
              <div class="Table--cell" v-if="elsInUse.InFrequency"><div style="padding: 0;">{{ elsLabel.InFrequency }}</div></div>
              <div class="Table--cell" v-if="elsInUse.InAmount"><div style="padding: 0;">{{ elsLabel.InAmount }}</div></div>
              <div class="Table--cell" v-if="elsInUse.InAgency"><div style="padding: 0;">{{ elsLabel.InAgency }}</div></div>
              <div class="Table--cell"  v-if="elsInUse.InBalance"><div style="padding: 0;"><div>{{ elsLabel.InBalance }}</div></div></div>
              <div class="Table--cell flex-1 text-center"><div style="padding: 0;">{{ $let('DeleteColumnContent') }}</div></div>
            </div>
          </div>

          <div class="Table--items">
            <div v-for="(item, idx) in displayValue" :key="idx">
              <div class="flex-row">
                <div class="Table--cell" v-if="elsInUse.OutInOutID"><div style="padding: 0;">{{ item.inOutID.Value }}</div></div>
                <div class="Table--cell" v-if="elsInUse.InFrequency"><div style="padding: 0;">{{ item.frequency.Value }}</div></div>
                <div class="Table--cell" v-if="elsInUse.InAmount"><div style="padding: 0;">{{ $formatCurrencyToUi(item.amount, currencyOptions) }}</div></div>
                <div class="Table--cell" v-if="elsInUse.InAgency"><div style="padding: 0;">{{ item.agency }}</div></div>
                <div class="Table--cell" v-if="elsInUse.InBalance"><div style="padding: 0;">{{ $formatCurrencyToUi(item.balance, currencyOptions) }}</div></div>
                <div class="Table--cell flex-1 text-center"><div style="padding: 0;">
                  <v-btn x-small fab color="error"
                    elevation="0"
                    @click="_removeFromList(idx)">
                      <v-icon red>mdi-close</v-icon>
                  </v-btn>
                </div>
                </div>
              </div>
            </div>  
          </div>  
        </div>    
      </div>

      <v-sheet v-if="type == constants.inOutType_Outgoing">
        
        <div :class="inError ? 'theme--light error--text shake' : ''" v-html="elsLabel.OutgoingList" class="subtitle-enquiry my-5 px-10"></div>
        <div v-show="inError" class="theme--light error--text mb-5 px-10" v-html="$let('RequiredFieldEmptyMessage')"></div >        
        
        <v-row class="financial-details_page px-10">
          <div v-if="elsInUse.OutInOutID" style="width: 100%;">
            <Combobox
              v-model="model.inOutID" 
              :items="inOutDS" 
              :returnObject="true"
              :label="elsLabel.OutInOutID"
              :helperText="elsHelperText.OutInOutID"
              :rules="[elsRequired.OutInOutID ? rules.required : true]">
            </Combobox>
          </div>
          <div v-if="elsInUse.OutFrequency" style="width: 100%;">
            <Combobox
              v-model="model.frequency" 
              :items="frequencyDS"
              :returnObject="true" 
              :label="elsLabel.OutFrequency"
              :helperText="elsHelperText.OutFrequency"
              :rules="[elsRequired.OutFrequency ? rules.required : true]">
            </Combobox>
          </div>
          <div v-if="elsInUse.OutAmount" style="width: 100%;">
            <Currency
              v-model="model.amount" 
              :label="elsLabel.OutAmount"
              :rules="[rules.numeric, rules.notZero, elsRequired.OutAmount ? rules.required : true]"
              :helperText="elsHelperText.OutAmount"
              :options="currencyOptions">
            </Currency>
          </div>
          <div v-if="elsInUse.OutAgency" style="width: 100%;">
            <TextField
              maxlength="20"
              v-model="model.agency" 
              :label="elsLabel.OutAgency"
              :helperText="elsHelperText.OutAgency"
              :rules="[rules.text, elsRequired.OutAgency ? rules.required : true]">
            </TextField>
          </div>
          <div v-if="elsInUse.OutBalance" style="width: 100%;">
            <Currency
              v-model="model.balance" 
              :label="elsLabel.OutBalance"
              :rules="[rules.numeric, elsRequired.OutBalance ? rules.required : true]"
              :helperText="elsHelperText.OutBalance"
              :options="currencyOptions">
            </Currency>
          </div>
          <div>
            <BaseButton
              @click="_addToList"
              :label="$let('AddToList')">
            </BaseButton>
          </div>
        </v-row>

        <div v-if="value && value.length > 0" class="Table--row mt-10">
          <div class="Table--data">
            <div class="flex-row"> 
              <div class="Table--cell" v-if="elsInUse.OutInOutID"><div style="padding: 0;">{{ elsLabel.OutInOutID }}</div></div>
              <div class="Table--cell" v-if="elsInUse.OutFrequency"><div style="padding: 0;">{{ elsLabel.OutFrequency }}</div></div>
              <div class="Table--cell" v-if="elsInUse.OutAmount"><div style="padding: 0;">{{ elsLabel.OutAmount }}</div></div>
              <div class="Table--cell" v-if="elsInUse.OutAgency"><div style="padding: 0;">{{ elsLabel.OutAgency }}</div></div>
              <div class="Table--cell" v-if="elsInUse.OutBalance"><div style="padding: 0;">{{ elsLabel.OutBalance }}</div></div>
              <div class="Table--cell flex-1 text-center"><div style="padding: 0;">{{ $let('DeleteColumnContent') }}</div></div>
            </div>
          </div>

          <div class="Table--items">  
            <div v-for="(item, idx) in displayValue" :key="idx">

              <div class="flex-row"> 
                <div class="Table--cell" v-if="elsInUse.OutInOutID"><div style="padding: 0;">{{ item.inOutID.Value }}</div></div>
                <div class="Table--cell" v-if="elsInUse.OutFrequency"><div style="padding: 0;">{{ item.frequency.Value }}</div></div>
                <div class="Table--cell" v-if="elsInUse.OutAmount"><div style="padding: 0;">{{ $formatCurrencyToUi(item.amount, currencyOptions) }}</div></div>
                <div class="Table--cell" v-if="elsInUse.OutAgency"><div style="padding: 0;">{{ item.agency }}</div></div>
                <div class="Table--cell" v-if="elsInUse.OutBalance"><div style="padding: 0;">{{ $formatCurrencyToUi(item.balance, currencyOptions) }}</div></div>
                <div class="Table--cell flex-1 text-center">
                  <div style="padding: 0;">
                    <v-btn x-small fab color="error"
                      elevation="0"
                      @click="_removeFromList(idx)">
                      <v-icon red>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-sheet>      

      <v-row class="px-10" style="margin:0;">
        <v-col style="margin:0;padding:0;">
          <StepperButtons
            @continueClick="_stepperContinue"
            @backClick="_stepperBack">
          </StepperButtons>
        </v-col>
      </v-row>

    </v-form>

    <Confirm
      :show="confirmMinLengthShow"
      :message="confirmMinLengthText" 
      :title="$let('ConfirmationTitleDefault')"
      :yesText="$let('ConfirmationYesLabelDefault')"
      :noText="$let('ConfirmationNoLabelDefault')"
      @yesClick="_confirmMinLengh"
      @noClick="_cancelMinLengh">
    </Confirm>    

  </div>
</template>

<script>
  
  import { mapGetters } from "vuex";
  import Currency from '@/shared/components/currency.vue';
  import TextField from '@/shared/components/text-field.vue';
  import Combobox from '@/shared/components/combobox.vue';
  import StepperButtons from './stepper-buttons.vue'
  import BaseButton from '@/shared/components/base-button.vue'
  import opmGeneric from '../utils/generic.js';
  import Confirm from "@/shared/components/confirm.vue";
  import constants from '../constants/generic.js';

  export default {
    name: 'FinancialDetails',
    components: { 
      StepperButtons, 
      Currency, 
      Confirm,
      TextField, 
      Combobox,
      BaseButton
    },
    emits: ["continueClick", "backClick"],
  props: {
      minLenght: { type: Number, default: 0 },
      required: { type: Boolean },
      rules: { type: Object },
      type: { 
        type: String, 
        validator(value) { return [constants.inOutType_Income, constants.inOutType_Outgoing].includes(value) }, 
      },
    },
    data: () => ({
      constants,
      inError: false,
      confirmMinLengthShow: false,
      confirmMinLengthText: "",
      currencyOptions: opmGeneric.currencyConfig(),
      inOutDS: [],
      frequencyDS: [],
      model: { },
      value: [],
      displayValue: []
    }),

    async created() {
      opmGeneric.setElementsConfig(this, this.elementsConfig);
      this.frequencyDS = this.referenceData ? this.referenceData.Frequencies : [];
      const thatType = this.type;
      this.inOutDS = this.referenceData ? this.referenceData.InOrOuts.filter(el => el.InOut === thatType) : [];
    },

    methods: {
      _stepperContinue() {
        if (this.required && (this.value.length == 0 || this.value.length < this.minLenght))
        {
          this.confirmMinLengthText = this.$let("MinExpendituresLengthText").replace("{0}", this.value.length);
          this.confirmMinLengthShow = this.value.length > 0 && this.type === constants.inOutType_Outgoing; // Show message on Expenditures only
          this.inError = true;
        }
        else {
          this.$refs.inputForm.reset();
          const retPropertyName = this.type === constants.inOutType_Income ? "incomeList" : "outgoingList";
          this.$emit("continueClick", { [retPropertyName] : this.value });
        }
      },

      _confirmMinLengh() {
        const retPropertyName = this.type === constants.inOutType_Income ? "incomeList" : "outgoingList";
        this.$emit("continueClick", { [retPropertyName]: this.value });
        this.confirmMinLengthShow = false;
      },
      _cancelMinLengh() {
        this.confirmMinLengthShow = false;
      },

      _stepperBack() { 
        this.$emit("backClick"); 
      },

      _addToList() {
        this.inError = false;
        if (this.$refs.inputForm.validate()) {
          this.value.push(opmGeneric.clone(this.model, true));
          this.displayValue.push(opmGeneric.clone(this.model));
          this.model = {};
          this.$refs.inputForm.reset();
        }
      },

      _removeFromList(idx) {
        this.value.splice(idx, 1);
        this.displayValue.splice(idx, 1);
      }
    },
    computed: {
      ...mapGetters(["referenceData", "elementsConfig"]),
    }
  }
  
</script>

<style scoped>
.shake {
  animation: shake 0.40s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shake {
  10%, 90% {
    transform: translate3d(1px, 0, 0);
  }
  40%, 70% {
    transform: translate3d(-2px, 0, 0);
  }
  50%, 80% {
    transform: translate3d(3px, 0, 0);
  }
}
</style>